export class ElectricalSettingsInfo {
    firstSlideName! : string;
    secondSlideName! : string;
    applyName! : string;
    restoreName! : string;
}